import { ResourceService } from '@socialbrothers/services';

import { ApiService } from '@Services/index';
import { IPartner } from '@Services/Partner';

export class PartnerServiceImplementation extends ResourceService<IPartner> {}

export const PartnerService = new PartnerServiceImplementation(ApiService, '/admin/partners');
